import React from 'react'
import PropTypes from 'prop-types'
import {withAnswer} from '#components/HOC/withAnswerHOC'
import TextareaResize from '#components/a/form/TextareaResize'
import QuestionDescription from './QuestionDescription'

export class QuestionFreitext extends React.Component {
  defaultAnswer = {text: ''}

  onChangeText = e => {
    this.props.updateAnswer({text: e.target.value})
    this.props.setHasUnsavedChanges(true)
  }

  onBlur = async () => {
    await this.props.saveAnswer()
    this.props.setHasUnsavedChanges(false)
  }

  render() {
    const {question, isReadOnly} = this.props
    const currentAnswer = this.props.currentAnswer || this.defaultAnswer
    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        <TextareaResize
          onChangeHandle={this.onChangeText}
          value={currentAnswer.text}
          onBlurHandle={this.onBlur}
          disabled={isReadOnly}
        />
      </>
    )
  }
}

QuestionFreitext.propTypes = {
  children: PropTypes.node.isRequired,
  updateAnswer: PropTypes.func.isRequired,
  saveAnswer: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  currentAnswer: PropTypes.object,
  question: PropTypes.object,
  setHasUnsavedChanges: PropTypes.func.isRequired,
}

export default withAnswer(QuestionFreitext)
